<script setup lang="ts">
import { ButtonV2, HugeIcon } from '@teachino/shared-design-system';
import { $t } from '@teachino/shared-i18n';
import { useLicense } from './useLicense';

const CHECKMARK_ICON_SIZE = 16;
const SCHOOL_ICON_SIZE = 20;

const { openSchoolLicense } = useLicense();

const schoolPerks = [
  $t('upgrade.license_page.school_perk_pro'),
  $t('upgrade.feature.ai.perk.collaboration'),
  $t('upgrade.feature.school.perk.student_accounts'),
  $t('upgrade.feature.school.perk.training'),
  $t('upgrade.feature.school.perk.cost_relief'),
];
</script>

<template>
  <section
    class="to-primary-50/30 relative overflow-hidden rounded-xl border border-slate-200/80 bg-gradient-to-br from-slate-50 via-white shadow-sm"
    :aria-label="$t('upgrade.license_page.upgrade_school.title')"
  >
    <div
      class="bg-primary-100/40 pointer-events-none absolute -top-8 -right-6 h-24 w-24 rounded-full blur-2xl"
      aria-hidden="true"
    />

    <div class="relative flex flex-col gap-5 p-5 md:p-6">
      <div class="flex min-w-0 items-start gap-4">
        <div
          class="border-primary-100 text-primary-600 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border bg-white shadow-sm"
        >
          <HugeIcon icon="school" :size="SCHOOL_ICON_SIZE" />
        </div>
        <div class="min-w-0">
          <h2 class="text-lg font-semibold text-slate-900">
            {{ $t('upgrade.license_page.upgrade_school.title') }}
          </h2>
          <p class="mt-1 text-sm leading-relaxed text-slate-600">
            {{ $t('upgrade.license_page.upgrade_school.subtitle') }}
          </p>
        </div>
      </div>

      <ul
        class="grid grid-cols-1 gap-3 border-t border-slate-200/80 pt-5 sm:grid-cols-2"
      >
        <li
          v-for="perk in schoolPerks"
          :key="perk"
          class="flex items-start gap-3 text-sm leading-relaxed text-slate-700"
        >
          <span class="text-primary-600 mt-0.5 shrink-0">
            <HugeIcon icon="checkmark_circle" :size="CHECKMARK_ICON_SIZE" />
          </span>
          <span>{{ perk }}</span>
        </li>
      </ul>

      <div class="flex justify-center pt-1">
        <ButtonV2
          variant="primary"
          icon="school"
          :label="$t('upgrade.school.cta')"
          @click="openSchoolLicense()"
        />
      </div>
    </div>
  </section>
</template>
